import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  row-gap: 48px;
  column-gap: 23px;
  @media (max-width: 1366px) {
    column-gap: 25px;
  }
`;
